import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Card, Alert, Spinner } from "react-bootstrap";
import { baseURL } from "../services/api";
import "../css/auth.css";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    
    try {
      await axios.post(`${baseURL}api/forgot-password`, { email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <Container fluid>
        <Card className="auth-card">
          <Card.Body className="auth-card-body">
            <h2 className="auth-title">Reset Password</h2>
            
            {error && (
              <Alert variant="danger" className="mt-3">
                {error}
              </Alert>
            )}

            {success ? (
              <Alert variant="success" className="mt-3">
                Password reset link has been sent to your email. Please check your inbox.
              </Alert>
            ) : (
              <>
                <p className="text-muted mb-4">
                  Enter your email address and we'll send you a link to reset your password.
                </p>
                
                <Form onSubmit={handleSubmit} className="auth-form">
                  <Form.Group controlId="formEmail" className="auth-form-group">
                    <Form.Label className="auth-label">Email address</Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="auth-input"
                      placeholder="Enter your email"
                      disabled={loading}
                    />
                  </Form.Group>

                  <Button 
                    variant="primary" 
                    type="submit" 
                    className="auth-button w-100"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Sending...
                      </>
                    ) : (
                      'Send Reset Link'
                    )}
                  </Button>
                </Form>
              </>
            )}

            <div className="text-center mt-3">
              <Button 
                variant="link" 
                className="auth-link" 
                onClick={() => navigate('/login')}
              >
                Back to Login
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default ForgotPassword;
